
var Endpoint = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2014",
      debug,
      fhirURL,
      tokens = {},
      clients = {},
      messageElt,
      endpointListeners = [], callListeners = [], authListeners = [];


  const callMap = {};
  var callCount = 0;

  const endpoints = {
    'https://api.healthterminologies.gov.au/integration/R4/fhir': '67ru485b2dhp7vgb14773sjp2',
    'https://api.healthterminologies.gov.au/integration': '7mb9ugsstb5itgmj3n67q0io8o',
    'https://api.dev.healthterminologies.gov.au/integration/R4/fhir': '2tpmiqmkh15ahqv8epj2urn646',
    // QCTS
    'https://api.dev.terminology.health.qld.gov.au/access/v1/fhir': '4sguvhpev85elgqh19m72ie96b',
    'https://api.uat.terminology.health.qld.gov.au/access/v1/fhir': '76qnke78v5gr227emn88b9ragq',
    'https://api.cit.terminology.health.qld.gov.au/access/v1/fhir': '4n4i776k6dmgm54rm6v77hiq8v',
    'https://api.terminology.health.qld.gov.au/access/v1/fhir': 'fajlot92ki57f03thusphpcr4',
    // Epic sandbox
    'https://fhir.epic.com/interconnect-fhir-oauth/api/FHIR/R4': '51f0e632-af0f-4eaf-adbd-991e6c925f9f',
  };

  function isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    var t = typeof obj;
    if (t === "boolean" || t === "number" ) return false;

    // Otherwise, does it have any properties of its own?
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

  function cleanResource(resource) {
    for (var key in resource) {
      if (typeof resource[key] === 'object') {
        cleanResource(resource[key]);
      }
      if (resource[key] && resource[key].constructor === Array) {
        resource[key] = resource[key].filter(function (obj) { return !isEmpty(obj); });
      }
      if (isEmpty(resource[key])) {
        delete resource[key];
      }
    }
    return resource;
  }

  return {
    settings: {
      fhirURL: "https://r4.ontoserver.csiro.au/fhir",	//"http://localhost:8090/fhir",	// "/ontoserver/resources/fhir",	// "http://ontoserver.csiro.au/fhir",
      messageElt: undefined,
    },

    init: function (flag) {
      debug = function() {
        if (flag) console.log.apply(this, arguments);
      }
      debug('Endpoint.init');
      messageElt = this.settings.messageElt;
    },

    initEndpoint: function (url, options) {
      if (url) {
        this.settings.fhirURL = url;
        if (options && options.access_token) {
            tokens[url] = options.access_token;
        }
        if (options && options.client) {
          clients[url] = options.client;
      }
    }
    },

    isLoggedIn: function() {
      const client = clients[fhirURL];
      const tt = client.getState('tokenResponse.token_type');
      return client && tt;
    },

    login: function () {
      const iss = fhirURL;
      const redirectUri = new URL('.', window.location.href).href;
      const clientId = endpoints[iss] || 'shrimp';
      const scopes = 'openid system/*.read';
// console.log('LOGIN XXX', clientId, iss, redirectUri, scopes);
      FHIR.oauth2.authorize({
        "iss": iss,
        "redirectUri": redirectUri,
        "clientId": clientId,
        "scope": scopes,
      });
    },

    logout: function () {
      const iss = fhirURL;
      const redirectUri = new URL('.', window.location.href).href;
      const clientId = endpoints[iss] || 'shrimp';
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('iss')
      history.pushState(null, '', '?' + urlParams.toString())
      FHIR.oauth2.authorize({
        "fhirServiceUrl": iss,
        "redirectUri": redirectUri,
        "clientId": clientId,
      });
    },

    trimLabel: function (fsn, code) {
      if (fsn) {
        return fsn
          .replace(/\s*\((SNOMED RT\+CTV3|attribute|body structure|morphologic abnormality|administrative|finding|disorder|environment \/ location|event|observable entity|organism|product|substance|physical force|physical object|procedure|qualifier value|record artifact|situation|metadata|social concept|special concept|specimen|staging scale|environment|geographic location|AU substance|AU qualifier|medicinal product[a-z ]*|trade product[a-z ]*|foundation metadata concept|relationship type)\)\s*$/, "")
        ;
      } else {
        return code ? (code + ' (no display)') : '***MISSING***';
      }
    },

    getVersions: function (options, callback) {
      if (!fhirURL) return;
      callEndpoint('json', "/CodeSystem/_search?"+
                           //"url:below="+encodeURIComponent("http://snomed.info/sct")+
                           //"&_elements=url,version,valueSet,name", "Versions", callback);
                           "_count=2000&"+
                           "_elements=url,version,valueSet,date,title,name,hierarchyMeaning,property,filter,content", "Versions", callback);
    },

    find: function (options, callback) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'format'	:	"json",
        'elements'	:	"id,name,source",
      });

      var s = this.settings,
          query = "/"+options.type+"?_elements="+options.elements;

      if (options.name) query = query + "&name="+options.name;
      if (options.url) query = query + "&url="+options.url;
      if (options.count) query = query + "&_count="+options.count;

      return callEndpoint(options.format, query, "Find", callback);
    },

    expand: function (options, callback) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'fields'	:	["code", "display"],
        'format'	:	"json",
      });

      if (options.url.startsWith('snapper:valueSet/')) {
        var hashId = options.url.substring(17),
            json = JSON.parse(window.localStorage['ngStorage-valueSets'] || '[]'),
            vs = json.find(function (vs) { return vs.uuid === hashId; });
        if (vs && vs.resource) {
          options.valueSet = cleanResource(vs.resource);
          return this.expandVs(options, callback);
        } else {
          console.log('Error, could not resolve ' + options.id);
          return callback('error');
        }
      }

      var s = this.settings,
          query = (options.id ? "/ValueSet/"+options.id+"/$expand?" : "/ValueSet/$expand?url="+encodeURIComponent(options.url));
      if (options.start) query = query + "&offset="+options.start;
      if (options.limit) query = query + "&count="+options.limit;
      if (options.includeDesignations) query = query + "&includeDesignations="+options.includeDesignations;

      return callEndpoint(options.format, query, "Search", callback);
    },

    expandVs: function (options, callback) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'fields'	:	["code", "display"],
        'format'	:	"json",
      });

      var s = this.settings,
          query = "/ValueSet/$expand?_format="+encodeURIComponent(options.format);
      if (options.start) query = query + "&offset="+options.start;
      if (options.limit) query = query + "&count="+options.limit;
      if (options.includeDesignations) query = query + "&includeDesignations="+options.includeDesignations;

      return callEndpoint(options.format, query, "Search", callback, options.valueSet);
    },

    translate: function (options, callback) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'format'	:	"json",
      });

      var s = this.settings,
          params = [
            '_format='+options.format,
            'code='+encodeURIComponent(options.code),
            'system='+encodeURIComponent(options.system),
            'target='+encodeURIComponent(options.target),
          ],
          query;

      if (options.url) { params.push('url='+encodeURIComponent(options.url)); }
      if (options.version) { params.push('version='+encodeURIComponent(options.version)); }

      if (options.id) {
          query = "/ConceptMap/"+options.id+"/$translate?";
      } else {
          query = "/ConceptMap/$translate?";
      }

      return callEndpoint(options.format, query + params.join('&'), "Translate", callback);
    },

    lookupConcepts: function (options, callback) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'codings'		:	[],
        'fields'	:	["code", "display"],
        'format'	:	"json",
        'start'		:	0,
        'limit'		:	10,
      });

      var s = this.settings;

      if (options.codings.length > 2000) {
        return callback('Too many concepts: ' + len); // protect ourselves
      } else if (options.codings.length > 1) {
        var bundle = {
            'resourceType': 'Bundle',
            'type': 'batch',
            'entry': options.codings.map(
                function (c) {
                  var params = [
                      'code='+encodeURIComponent(c.c),
                      'system='+encodeURIComponent(c.s),
                  ];
                  if (c.v) { params.push('version='+encodeURIComponent(c.v)); }
                  return {
                    'request': {
                      'method': 'GET',
                      'url': 'CodeSystem/$lookup?'+params.join('&') + '&property='+options.fields.join('&property=') // '&property=display&property=parent&property=designation&property=inactive' //,processFields(options.fields),
                    },
                  };
                }
            ),
        };
        return callEndpoint(options.format, '', "Lookup", callback, bundle);
      } else if (options.codings.length == 1) {
        var c = options.codings[0],
            params = [
              'code='+encodeURIComponent(c.c),
              'system='+encodeURIComponent(c.s),
            ],
            fields = options.fields.map(function (f) { return encodeURIComponent(f); }),
            lookupUrl;
        if (c.v) { params.push('version='+encodeURIComponent(c.v)); }
        lookupUrl = '/CodeSystem/$lookup?'+params.join('&') + '&property='+fields.join('&property=');

        var cb = function (error, result) {
          if (error) {
            return callback(error, result);
          } else {
            return callback(error, [{resource: result}]);
          }
        };

        return callEndpoint(options.format, lookupUrl, "Lookup", cb);
      } else {
        return callback(undefined, []);
      }

    },

    findConceptsByTermPrefixes: function (options, callback) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'terms'		:	"",
        'fields'	:	["code", "display"],
        'includeDesignations' : false,
        'filter'	:	'http://snomed.info/sct?fhir_vs',
        'boost'		:	[],
        'format'	:	"json",
        'start'		:	0,
        'limit'		:	10,
      });

      var s = this.settings,
          params,
          queryString = encodeURIComponent(options.terms),
          elements = processFields(options.fields, 'expansion.contains.'),
          valueset = options.valueset,
          query = "/ValueSet/$expand?_format="+options.format;

      if ('object' === typeof valueset) {
        params = {
          "resourceType": "Parameters",
          "parameter": [{
            "name": "valueSet",
            "resource": valueset
          }]
        };
        if (queryString) {
          params.parameter.push({
              "name": "filter",
              "valueString": queryString,
          });
        }
        if (options.systemVersion) {
          params.parameter.push({
            "name": "system-version",
            "valueCanonical": options.systemVersion,
          });
        }
        if (options.includeDesignations) {
          params.parameter.push({
              "name": "includeDesignations",
              "valueBoolean": options.includeDesignations,
          });
        }
        if (options.limit) {
          params.parameter.push({
              "name": "count",
              "valueInteger": options.limit,
          });
        }
        if (elements) {
          params.parameter.push({
              "name": "elements",
              "valueString": elements,
          });
        }
      } else {
        if (options.filter) {
          query = query + "&url="+encodeURIComponent(options.filter);
        } else {
          throw new Error('No ValueSet URI provided');
        }

        if (queryString) {
          query = query + "&filter="+queryString;
        }
        if (options.systemVersion) {
          query = query + "&system-version="+encodeURIComponent(options.systemVersion);
        }
        if (options.includeDesignations) {
          query = query + "&includeDesignations=true";
        }
        if (options.limit) {
          query = query + "&count="+encodeURIComponent(options.limit);
        }
        if (elements) {
          query = query + "&elements="+elements;
        }
      }

      return callEndpoint(options.format, query, "Search", callback, params);
    },

    findRootConcepts: function (options, callback) {
      console.log('findRootConcepts is deprecated');
      callback(undefined, {});
    },

    findConceptsByQuery: function (options, callback) {
      if (!fhirURL) return;
      if (!Array.isArray(options.system)) {
        options.system = [options.system];
      }
      var query = this.getFindConceptsByQuery(options),
          disjunction = options.disjunction || [{query: options.query, systems: options.system, valueSet: options.valueSet,}],
          filters = function (q) {
                      return Array.apply(null, {length: q.length/3})
                         .map(function(value, index) {
                           var base = 3 * index;
                           return {
                             "property": q[base],
                             "op": q[base+1],
                             "value": q[base+2],
                           };
                         });
                    },
          valueSet = {
            "resourceType": "ValueSet",
            "compose": {
              "include": disjunction.flatMap(function (d) {
                return d.systems.map(function(s, i) {
                  var inc = {
                    "system": s,
                    "filter": filters(d.query),
                  };
                  if (d.versions) {
                    inc.version = d.versions[i];
                  }
                  return inc;
                }).concat(d.valueSet ? [{
                  "valueSet": d.valueSet,
                  "filter": filters(d.query),
                }] : []);
              })
            }
          },
          params = {
            "resourceType": "Parameters",
            "parameter": [{
              "name": "valueSet",
              "resource": valueSet,
            }]
          };

      if (options.parents) {
        params.parameter.push({
          "name": "property",
          "valueString": "sufficientlyDefined",
        });
        params.parameter.push({
          "name": "property",
          "valueString": "inactive",
        });
        params.parameter.push({
          "name": "property",
          "valueString": "parent",
        });
      }

      if (options.activeOnly) {
        params.parameter.push({
              "name": "activeOnly",
              "valueBoolean": options.activeOnly,
            });
      }

      if (options.start) {
        params.parameter.push({
              "name": "offset",
              "valueInteger": options.start,
            });
      }

      if (options.limit) {
        params.parameter.push({
              "name": "count",
              "valueInteger": options.limit,
            });
      }

      if (options.version) {
        valueSet.compose.include[0].version = options.version;
      }

      return callEndpoint(options.format, query, "Query", callback, params);
    },

    getFindConceptsByQuery: function (options) {
      if (!fhirURL) return;
      mergeDefaults(options, {
        'query'		:	"None",
        'fields'	:	["shortId", "label"],
        'format'	:	"json",
        'start'		:	0,
        'limit'		:	10,
        'filename'	:	null,
      });

      var base = "/ValueSet";
      if (options.id) {
        base = "/ValueSet/" + options.id;
        options.id = undefined;
        options.query = undefined;
      }

      var s = this.settings,
          filename = options.filename ? "&filename="+encodeURIComponent(options.filename) : "",
          url = base+"/$expand?_format="+options.format;

          if (options.fields.length > 0) {
            return url + '&elements=' + processFields(options.fields, 'expansion.contains.');
          } else {
            return url + processFields(options.fields);
          }
    },

    setVersion: function (systemId, versionId, valueset) {
      console.log('setVersion deprecated');
    },

    setEndpoint: function (url, options) {
      debug('setEndpoint', url);
      if (!url || '' === url) {
        url = Endpoint.settings.fhirURL;
      }

      if (fhirURL !== url) {
        if (options) {
          if (options.client) {
            clients[url] = options.client;
          }
          if (options.access_token) {
            tokens[url] = options.access_token;
          }
        }

        fhirURL = url;
        notify(endpointListeners, url);
      }
    },

    addListener: function (listener) { endpointListeners.push(listener); },
    addCallListener: function (listener) { callListeners.push(listener); },
    addAuthListener: function (listener) { authListeners.push(listener); },
  };

  function notify(listeners, payload) {
    listeners.forEach(function (callback) {
      try {
        callback(payload);
      } catch (err) {
        console.log('endpoint listener', err);
      }
    });
  }

  function mergeDefaults(options, defaults) {
    for (var key in defaults) {
      if(typeof options[key] === "undefined") options[key] = defaults[key];
    }
  }

  function processFields(fields, prefix) {
    if (fields.length > 0) {
      return fields.map(function(f) { return (prefix||'')+f; }).join(",");
    } else {
      return undefined;
    }
  }

  function processFilter(filters) {
    if (filters.length > 0) {
      return "&filter="+filters.map(encodeURIComponent).join("&filter=");
    } else {
      return "";
    }
  }

  function processBoost(boosts) {
    if (boosts.length > 0) {
      return "&booster="+boosts.map(encodeURIComponent).join("&booster=");
    } else {
      return "";
    }
  }

  function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  function inc(uuid) {
    callCount = callCount + 1;

    if (callMap[uuid]) {
      console.error('collision:', ctxt, uuid, callMap[uuid], callCount)
    }
    callMap[uuid] = callCount;

    notify(callListeners, callCount);
  }

  function dec(uuid, ctxt) {
    if (callCount > 0) {
      callCount = callCount - 1;

      if (!callMap[uuid]) {
        console.error('nomatch:', ctxt, uuid, callMap);
      }

      notify(callListeners, callCount);
    } else {
      console.error('ERROR: callCount out of sync:', ctxt, callCount, uuid, callMap[uuid]);
    }
    delete callMap[uuid];
    if (callCount !== Object.keys(callMap).length) {
      console.error('size mismatch', ctxt, callCount, callMap)
    }
  }

  function callEndpoint(format, query, title, callback, body) {
    return doCallEndpoint(format, fhirURL+query, title, callback, body);
  }

  function doCallEndpoint(format, query, title, callback, body) {
    const queryUrl = new URL(query);
    if ('http:' === queryUrl.protocol && 'https:' == window.location.protocol) {
      console.log('Upgrading HTTP URL to HTTPS to avoid mixed content error');

      queryUrl.protocol = 'https:';
      query = queryUrl.toString();
    }
    const uuid = uuidv4();
    debug('XHR+', uuid, callCount, query, new Error().stack);
    var // stack = new Error().stack,
        wrapper = function(error, data) {
      dec(uuid, 'done');
      debug('XHR-', uuid, callCount, query);
// console.log('r',error,data);
      if (error) {
        if (messageElt) {
          if (error.status >= 400 && error.status < 500) {
            // client error
          } else {
            messageElt.text(new Date().toLocaleTimeString()+' '+title+': ('+error.status+') '+(''===error.statusText?'Unknown - server down or possible CORS error':error.statusText));
            setTimeout(function () {
              messageElt.text('');
            }, 5*1000);
          }
        }
        // console.log(title + ': problem (' + error.status + ') with ' + query + '\nBODY\t'+JSON.stringify(body)+ '\nRESP:\t:' + error.responseText);
        // ga('send', 'exception', { 'exDescription': error.responseText, 'exFatal': error.status >= 500 || error.status < 0 });
      }

      if (true) {
        if (!error) {
          if ('Bundle' === data.resourceType) {

            if (data.link) {
              // Check for paging
              var next = data.link.find(function(l) {return l.relation === 'next';});
              if (next && next.url) {
// console.log('NEXT', query, title, data.entry && data.entry.length, data.link);
                var cb = callback;
                callback = function (cb_err, cb_data) {
                  doCallEndpoint(format, next.url, title, function (e,d) {
                    debug('url', next.url, e, d ? d.length : -1);
                    if (e) {
		      console.log(e.status, e.statusText);
                      cb((e.status >= 400 && e.status < 500) ? undefined : e, cb_data);
                    } else {
                      Array.prototype.unshift.apply(cb_data, d);
                      cb(e, cb_data);
                    }
                  });
                };
              }
            }

            data = data.entry || [];
          } else if ('ValueSet' === data.resourceType) {
            data = data.expansion || {};
            processVersions(data);
          } else {
            // console.log('type', data.resourceType);
          }
        } else {
          var notJson = error.getResponseHeader && error.getResponseHeader('Content-Type').toLowerCase().indexOf('json') < 0,
              err = (!notJson && error.response) ? JSON.parse(error.response) : error;
          // console.log('error', err);
          // if (body) console.log('error:body', JSON.stringify(body));
        }
        callback(error, data);
        return;
      }

      // poor man's promise
      return {
        then: function (success, failure) {
          if (error) {
            return failure(error);
          } else {
            return success(data);
          }
        },
      };
    };

// console.log('q', format, query, body);
    if ("json" === format) {
      inc(uuid);
      // ga('send', 'pageview', {'page': query, 'title': "Shrimp: " + title});
      var token = tokens[fhirURL],
          client = clients[fhirURL],
          req;

      if (client) { // using fhir-js
        const abortController = new AbortController();
        const signal = abortController.signal;
        const resultObj = {
          running: true,
          abort: function () {
            if (this.running) {
              debug('abort', this.running, query, body);
              this.running = false;
              dec(uuid, 'abort');
              abortController.abort();
            }
          },
        };
        const options = {
          url: query,
          method: 'GET',
          headers: {
            "Accept": "application/fhir+json",
          },
          signal
        };
        if (body) {
          options.method = 'POST';
          options.headers["Content-Type"] = "application/fhir+json";
          options.body = JSON.stringify(body);
        }
        client.request(options).then(function (result) {
          resultObj.running = false;
          wrapper(undefined, result);
        }).catch(function (error) {
          if (resultObj.running) {
            debug('CLIENT ERROR', resultObj.running, error);
            resultObj.running = false;
            const msg = error?.message;
            if (msg) {
              if (msg.startsWith('This app cannot be accessed directly.')) {
                authListeners.forEach(function (callback) {
                  try {
                    callback(error);
                  } catch (err) {
                    console.log('auth listener', err);
                  }
                });
              }
            }
            if ((error+'').includes('Unable to refresh.')) {
              window.location = `launch.html?iss=${fhirURL}`;
            }
            wrapper(error);
          }
        });

        return resultObj;
      }

      if (body) {
        var request =
              d3.json(query)
                .header("Content-Type","application/fhir+json")
                .header("Accept","application/fhir+json");
        if (token) {
          request = request.header("Authorization","Bearer "+token);
        }
        req = request.post(JSON.stringify(body), wrapper);
      } else {
        var request =
              d3.json(query)
                .header("Accept","application/fhir+json");
        if (token) {
          request = request.header("Authorization","Bearer "+token)
        }
        req = request.get(wrapper);
      }
      return {
        abort: function() {
          setTimeout(function () {
            console.log('abort', query, req);
            if (req) req.abort();
            dec(uuid, 'timeout');
          }, 1);
        },
      };
//    } else if ("csv" === format) {
//      ga('send', 'pageview', {'page': query, 'title': "Shrimp: " + title});
//      return d3.csv(query, wrapper);
//    } else if ("tsv" === format) {
//      ga('send', 'pageview', {'page': query, 'title': "Shrimp: " + title});
//      return d3.tsv(query, wrapper);
    } else {
      console.log("Unsupported format: " + format);
      return null;
    }
  }

  function processVersions(expansion) {
    var rows = expansion.contains,
        versions = {};

    if (!rows) return;

    (expansion.parameter || [])
      .filter(function (p) { return "version" === p.name; })
      .map(function (p) { return p.valueUri; })
      .forEach(function (v) {
        var fields;
        if (v.indexOf('?version=') < 0) {
          fields = v.split('|');
        } else {
          fields = v.split('?version=');
        }
        if (fields.length == 2) {
          versions[fields[0]] = decodeURIComponent(fields[1]);
        }
      });

    rows.forEach(function (row) {
      row.version = row.version || versions[row.system];
    });
  }

}());

